import { createAction, props } from '@ngrx/store';
import { AuctionState } from 'src/app/store/reducers/auction.reducer';

export const set_auction    = createAction('[Auction] Set Auction', props<{ auction: AuctionState }>());
export const load_auction   = createAction('[Auction] Load Auction', props<{ uid: string }>());
export const clear_auction  = createAction('[Auction] Clear Auction');
export const update_items   = createAction('[Auction] Update Items', props<{ items: any }>());
export const update_bids    = createAction('[Auction] Update Bids', props<{ bids: any }>());
export const set_state      = createAction('[Auction] Set State', props<{ state: string }>());